export default __webpack_public_path__ + "static/media/contextual-chocolate.81a7d952.png";